import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { Fragment } from "react";
import { IconTranslator } from "components/icons/Icons";
import { fetchLanguagesExcerpt } from "network/helper";
import { LanguagesExcerptWithToggle } from "../../projectsTable/components/LanguagesExcerptWithToggle";

interface LanguageCellProps {
  sourceLanguage?: string;
  targetLanguage?: string;
  availableTargetLanguages: string[];
  onTargetLanguageChange: (value: string) => void;
}

export function LanguageCell({
  sourceLanguage,
  targetLanguage,
  availableTargetLanguages,
  onTargetLanguageChange,
}: LanguageCellProps) {
  const textColor = useColorModeValue("black", "black");

  return (
    <Flex align="center">
      {sourceLanguage && targetLanguage && (
        <Fragment>
          <Text
            color={textColor}
            fontSize="14px"
            lineHeight="24px"
            fontWeight="400"
          >
            {fetchLanguagesExcerpt(sourceLanguage)}
          </Text>
          <IconTranslator width="15px" height="16px" mx="4px" />
          <LanguagesExcerptWithToggle value={targetLanguage} />
          {/* //TODO: it is necessary to make it possible to edit after adding the api  */}
          {/* <TargetLanguagesMultiSelect
            value={targetLanguage}
            options={availableTargetLanguages}
            onChange={onTargetLanguageChange}
          /> */}
        </Fragment>
      )}
    </Flex>
  );
}
